export default "__VITE_ASSET__DCUN_Dpn__"